import type { CompanyAccountInput, CompanyAccountKind, CompanyAccountView } from '@chukua/common';

/** Every field of every kind, because the form shows only the kind's own and the rest stay empty. */
export interface CompanyAccountFormValues {
  kind: CompanyAccountKind;
  name: string;
  bankName?: string;
  accountNumber?: string;
  paybillNumber?: string;
  tillNumber?: string;
}

/** Sends only the fields the kind uses; the API refuses the others. */
export function toCompanyAccountInput(values: CompanyAccountFormValues): CompanyAccountInput {
  const name = values.name.trim();
  if (values.kind === 'bank') return { kind: 'bank', name, bankName: (values.bankName ?? '').trim(), accountNumber: (values.accountNumber ?? '').trim() };
  if (values.kind === 'mpesa_paybill') return { kind: 'mpesa_paybill', name, paybillNumber: (values.paybillNumber ?? '').trim() };
  return { kind: 'mpesa_till', name, tillNumber: (values.tillNumber ?? '').trim() };
}

export function toCompanyAccountFormValues(account: CompanyAccountView): CompanyAccountFormValues {
  return {
    kind: account.kind,
    name: account.name,
    bankName: account.bankName ?? undefined,
    accountNumber: account.accountNumber ?? undefined,
    paybillNumber: account.paybillNumber ?? undefined,
    tillNumber: account.tillNumber ?? undefined,
  };
}

/** Why the server would refuse an M-Pesa number, so the form says so before it is sent. */
export const MPESA_NUMBER_RULE = { pattern: /^\s*\d{5,7}\s*$/, message: 'Enter the 5 to 7 digit number' };
